import controller from './icon.controller';
import template from './icon.html';

export default {
	template,
	bindings: {
		mimetype: '<',
	},
	controller,
};
